export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  RatherNotSay = 'RATHER_NOT_SAY',
}
